module.exports = __webpack_public_path__ + "static/img/狗子.58b3ff56.png";